import React from 'react';

export const sectionHeaderStyle: React.CSSProperties = {
  fontSize: '12px',
  textTransform: 'uppercase',
  color: '#888',
  marginBottom: '10px',
  marginTop: '20px',
  fontWeight: 'bold',
  letterSpacing: '1px'
};

export const buttonStyle: React.CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '8px 12px',
  marginBottom: '8px',
  background: 'rgba(255, 255, 255, 0.05)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '4px',
  color: '#ecf0f1',
  cursor: 'pointer',
  textAlign: 'left',
  fontSize: '13px',
  transition: 'all 0.2s'
};

export const statusBadgeStyle = (connected: boolean): React.CSSProperties => ({
  display: 'inline-block',
  padding: '4px 8px',
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: 'bold',
  backgroundColor: connected ? 'rgba(46, 204, 113, 0.2)' : 'rgba(231, 76, 60, 0.2)',
  color: connected ? '#2ecc71' : '#e74c3c',
  border: `1px solid ${connected ? 'rgba(46, 204, 113, 0.4)' : 'rgba(231, 76, 60, 0.4)'}`
});

export const playerCardStyle: React.CSSProperties = {
  padding: '10px',
  background: 'rgba(255, 255, 255, 0.05)',
  borderRadius: '6px',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  marginBottom: '8px'
};
